import { Phone, Mail } from 'lucide-react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-navy py-16">
        <div className="container mx-auto px-4">
          <h1 className="font-oswald text-4xl md:text-5xl font-bold text-white text-center">
            Privacy Policy
          </h1>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-8">
              <strong>Effective Date:</strong> April 27, 2026
            </p>

            <p className="text-gray-700 mb-8">
              Bruce Nelson Plumbing & Heating ("Company," "we," "our," or "us") is committed to protecting your privacy.
            </p>

            <h2 className="font-oswald text-2xl font-bold text-navy mt-8 mb-4">1. Information We Collect</h2>
            <p className="text-gray-700 mb-6">
              Name, phone, email, service address, and service request details. Also IP, browser, and usage data.
            </p>

            <h2 className="font-oswald text-2xl font-bold text-navy mt-8 mb-4">2. How We Use Your Information</h2>
            <p className="text-gray-700 mb-6">
              Appointments, communication, reminders, support, improvements, and marketing (if opted in).
            </p>

            <h2 className="font-oswald text-2xl font-bold text-navy mt-8 mb-4">3. SMS/Text Messaging</h2>
            <p className="text-gray-700 mb-6">
              You consent to receive SMS including reminders, updates, and promotions. Message frequency may vary. Message and data rates may apply.
            </p>

            <h2 className="font-oswald text-2xl font-bold text-navy mt-8 mb-4">4. Opt-Out</h2>
            <p className="text-gray-700 mb-6">
              Reply STOP to unsubscribe or HELP for assistance.
            </p>

            <h2 className="font-oswald text-2xl font-bold text-navy mt-8 mb-4">5. Data Protection</h2>
            <p className="text-gray-700 mb-6">
              <strong>We do not sell, rent, or share your opt-in data and phone numbers with third parties for marketing or promotional purposes.</strong>
            </p>

            <h2 className="font-oswald text-2xl font-bold text-navy mt-8 mb-4">6. Usage Transparency</h2>
            <p className="text-gray-700 mb-6">
              Used only for service delivery and communication.
            </p>

            <h2 className="font-oswald text-2xl font-bold text-navy mt-8 mb-4">7. Cookies</h2>
            <p className="text-gray-700 mb-6">
              Used for performance and UX.
            </p>

            <h2 className="font-oswald text-2xl font-bold text-navy mt-8 mb-4">8. Security</h2>
            <p className="text-gray-700 mb-6">
              We protect your data with safeguards.
            </p>

            <h2 className="font-oswald text-2xl font-bold text-navy mt-8 mb-4">9. Your Rights</h2>
            <p className="text-gray-700 mb-6">
              Access, update, or delete your data.
            </p>

            <h2 className="font-oswald text-2xl font-bold text-navy mt-8 mb-4">10. Contact Information</h2>
            <div className="bg-gray-50 p-6 rounded-lg mb-6">
              <p className="font-bold text-navy mb-2">Bruce Nelson Plumbing & Heating</p>
              <p className="text-gray-700 flex items-center gap-2 mb-1">
                <Phone className="w-4 h-4" /> 651-738-9354
              </p>
              <p className="text-gray-700 flex items-center gap-2">
                <Mail className="w-4 h-4" /> info@brucenelsonph.com
              </p>
            </div>

            <h2 className="font-oswald text-2xl font-bold text-navy mt-8 mb-4">11. Updates</h2>
            <p className="text-gray-700 mb-6">
              We may update this policy periodically.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
